<template>
  <section
    class="index-header"
    :class="{ 'is-opacity': isOpacity && scrollTop < 120 }"
  >
    <div class="inner">
      <div class="left">
        <div class="logo">
          <router-link to="/">
            <img class="default-img" src="@/assets/logo/logo-short-h.png" />
            <img class="white-img" src="@/assets/logo/logo-short-h-white.png" />
          </router-link>
        </div>
        <div class="nav">
          <div class="nav-item">
            <router-link to="/platform">平台</router-link>
          </div>
          <div class="nav-item">
            <a>
              资源
              <i class="el-icon-caret-bottom el-icon--right"></i>
            </a>
            <ul class="submenus">
              <li>
                <router-link to="/success-stories">成功经历</router-link>
              </li>
              <li>
                <router-link to="/knowledge-centre">知识中心</router-link>
              </li>
            </ul>
          </div>

          <div class="nav-item">
            <a>
              产品介绍

              <i class="el-icon-caret-bottom el-icon--right"></i>
            </a>
            <ul class="submenus">
              <li>
                <router-link to="/customs">关务管理平台</router-link>
              </li>
              <li>
                <router-link to="/tradeCompliance">全球贸易合规</router-link>
              </li>
            </ul>
          </div>
          <div class="nav-item">
            <router-link to="/partners">合作伙伴</router-link>
          </div>
          <div class="nav-item">
            <a>
              公司
              <i class="el-icon-caret-bottom el-icon--right"></i>
            </a>
            <ul class="submenus">
              <li>
                <router-link to="/about">关于</router-link>
              </li>
              <li>
                <router-link to="/careers">职业生涯</router-link>
              </li>
              <li>
                <router-link to="/media-center">媒体中心</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="right">
        <button class="goto" @click="handleJumpPage(1)">立即启航</button>
        <!-- <div class="lang">
          <img src="@/assets/home/qiu.svg" alt="" />
          <select class="lang-select">
            <option value="zh">中文</option>
            <option value="en">EN</option>
          </select>
          <i class="el-icon-caret-bottom el-icon--right lang-select-icon"></i>
        </div> -->
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'indexHeader',
  data() {
    return {
      activeIndex: '/',
      scrollTop: 0
    }
  },
  props: {
    useOpacity: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isOpacity() {
      return ['', '/', '/index'].includes(this.$route.path)
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    handleSelect(value) {
      console.log('🚀 ~ handleSelect ~ value:', value)
    },
    handleJumpPage() {
      this.$router.push('/consultation')
      // window.open('http://13.8.70.235:28384/xcp/index')
    },
    onScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop
    }
  }
}
</script>

<style scoped lang="less">
.index-header {
  position: fixed;
  top: 0;
  z-index: 999;
  width: 100%;
  height: 80px;
  background-color: #fff;
  box-shadow: 0px 4px 35px 0px rgba(42, 43.00000000000001, 47, 0.07);
  transition: all 0.4s;
  &.is-opacity {
    &:not(&:hover) {
      background: linear-gradient(180deg, #0006 0%, #0000 100%);
      box-shadow: none;
      .inner .left .logo {
        .default-img {
          display: none;
        }
        .white-img {
          display: block;
        }
        margin-right: 40px;
      }
      .inner .left .nav {
        .nav-item {
          & > a {
            color: #fff;
          }
        }
      }
      .inner .right .goto {
        border-color: #fff;
        color: #fff;
      }
    }
  }
  .inner {
    width: 100%;
    max-width: 1140px;
    height: 40px;
    margin: 0 auto;
    padding: 20px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      display: flex;
      align-items: center;
      gap: 30px;
      .logo {
        width: 120px;
        height: 54px;
        position: relative;
        margin-right: 40px;
        img {
          // width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
        }
        .default-img {
          display: block;
        }
        .white-img {
          display: none;
        }
      }
      .nav {
        display: flex;
        align-items: center;
        gap: 20px;
        .nav-item {
          flex: 1;
          min-width: 100px;
          text-align: center;
          position: relative;
          a {
            color: #2a2b2f;
            font-weight: 700;
            font-size: 16px;
          }
          .submenus {
            max-height: 0;
            overflow: hidden;
            transition: all 0.8s;
            position: absolute;
            left: 0;
            top: 36px;
            min-width: 100%;
            max-width: 1000px;
            width: 140px;
            background-color: #fff;
            li {
              padding: 13px 20px;
              text-align: left;
              &:hover > a {
                color: #2f5ad9;
              }
            }
          }
          &:hover {
            & > a {
              color: #2f5ad9;
            }
            & > .submenus {
              max-height: 200px;
            }
          }
        }
      }
    }
    .right {
      display: flex;
      align-items: center;
      gap: 20px;
      .goto {
        cursor: pointer;
        width: 175px;
        height: 40px;
        border: #2f5ad9 solid 3px;
        border-radius: 40px;
        text-align: center;
        line-height: 40px;
        color: #2f5ad9;
        font-size: 18px;
        font-weight: 700;
        &:hover {
          background-color: #2f5ad9;
          color: #fff;
        }
      }
      .lang {
        display: flex;
        align-items: center;
        .lang-select {
          margin-left: 10px;
          width: 80px;
        }
        .lang-select-icon {
          transform: translateX(-30px);
        }
      }
    }
  }
}
</style>
